import React, { FC, useState } from 'react'
import styled from 'styled-components'
import { Dialog, DialogTitle, DialogContent, FormControlLabel } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { theme, Text, Row, Space, Icon, Image, Spinner } from 'ui'
import { Button, Table, TableBody, TableCell, TableRow, TableHead, RadioGroup, Radio, Checkbox, IconButton,  Select, InputLabel, MenuItem } from '@material-ui/core'
import { Edit, Delete, Add, Close } from '@material-ui/icons'

import { TextField } from '@material-ui/core'
import { observer } from 'mobx-react'
import useStore from 'store'

import EmergencyIcon from 'assets/icons/ims/Emergency.svg'

const SectionEmergency = styled.div`
  display: flex;
  padding: 26px;
  flex-direction: column;
  align-items: flex-start;
  gap: 23.991px;
  flex-shrink: 0;
  align-self: stretch;
  border-radius: 12px;
  border: 1.818px solid rgba(255, 201, 201, 0.50);
  background: linear-gradient(135deg, #FEF2F2 0%, #FFF7ED 100%);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.10), 0 1px 2px -1px rgba(0, 0, 0, 0.10);
`
const EmergencyHeader = styled.div`
  display: flex;
  height: 53.793px;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  align-self: stretch;
  border-bottom: 1.818px solid #FFC9C9;
`
const EmergencyContainerButton = styled(Button)`
  display: flex;
  height: 52px;
  padding: 13px 25px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  align-self: stretch;
  border-radius: 8px;
  border: 1.818px solid #FFA2A2;
  background: #FEF2F2;
  color: #C10007;
  text-align: right;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`
const EmergencyHeaderTitle = styled.div`
  display: flex;
  height: 53.793px;
  justify-content: flex-start;
   align-items: center;
  gap: 12px;
  flex-shrink: 0;
  align-self: stretch;
  color: #82181A;
  font-family: Rubik;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px; /* 140% */
`
const ImageIcon2 = styled(Image)`
  flex-shrink: 0;
  align-self: center;
  border-radius: 8px;
  display: flex;
  width: 39.986px;
  height: 39.986px;
  padding: 7.997px 7.997px 7.997px 7.997px;
  flex-direction: column;
  align-items: flex-start;
  background: #FB2C36;
`
const SingleEmergencyContact = styled.div`
  display: flex;
  padding: 16.903px 16.903px 0.909px 16.903px;
  flex-direction: column;
  align-items: flex-start;
  gap: 11.989px;
  flex-shrink: 0;
  align-self: stretch;
  border-radius: 8px;
  border: 0.909px solid #FFC9C9;
  background: rgba(254, 242, 242, 0.50);
`
const TopContainer = styled.div`
  display: flex;
  height: 23.991px;
  padding-right: 0;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  align-self: stretch;
`
const BottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 15.994px;
  flex-shrink: 0;
  align-self: stretch;
`
const StyledDelete = styled(Delete)`
  color: #DC2626; 
  font-size: 16px;
`
const StyledIconButton = styled(IconButton)`
  padding: 8px;
`
const Title = styled.div`
  display: flex;
  justify-content: center; 
  align-items: center;
  color: #82181A;
  text-align: right;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`
const Label = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  align-self: stretch;
  color: #64748B;
  text-align: right;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`
const RowContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 7.997px;
  flex-shrink: 0;
  align-self: stretch;
`
const RadioContainer  = styled.div` 
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 15.994px;
  flex-shrink: 0;
  align-self: stretch;
`
const StyledFormControlLabel = styled(FormControlLabel)`
  & .MuiIconButton-root {
    width: 16px;
    height: 16px;
    margin-left: 3px;
  }

  & .MuiTypography-body1 {
    color: #0F172A;
    text-align: right;
    font-family: Rubik;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
  }
`
const StyledSelect = styled.select`
  display: flex;
  width: 100%;
  padding: 14px 10px;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  align-self: stretch;
  border-radius: 6px;
  border: 0.909px solid #E2E8F0;
  background: #F8FAFC;
`
const StyledInput = styled.input`
  height: 42px;
  width: 100%;
  min-width: 250px;
  flex-shrink: 0;
  align-self: stretch;
  border-radius: 6px;
  border: 0.909px solid #E2E8F0;
  background: #F8FAFC;
`
const ContactPersonContainer = styled.div` 
  display: flex;
  width: 100%;
  padding: 4.81px 13.383px 4.986px 1006.207px;
  justify-content: flex-end;
  align-items: center;
  align-self: stretch;
  border-radius: 6px;
  border: 0.909px solid #DBEAFE;
  background: #EFF6FF;
`
const ContactPersonLabel = styled.div`
  display: flex;
  width: 100%;
  color: #64748B;
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
`

export type EmergencyContact = {
  mode: 'select' | 'manual'
  id?: string
  name?: string
  phone?: string
  address?: string
}

export type EmergencyPayload = {
  contacts: EmergencyContact[]
}

const EmergencySection = ({ value, onChange, disableEdit }) => {
  const { members, orgs, uiStore, memberStore, imsUsersStore } = useStore()
  const { t } = useTranslation('members')

  const normalizePhone = (v: string): string => {
    const stripped = v.replace(/-/g, '')
    return /^0\d{9}$/.test(stripped) ? '+972' + stripped.slice(1) : stripped
  }

  const displayPhone = (v: string): string => {
    const raw = v?.startsWith('+972') ? '0' + v.slice(4) : (v || '')
    return raw.length >= 3 ? raw.slice(0, 2) + '-' + raw.slice(2) : raw
  }

  const update = (contacts) => {
    onChange({ contacts })
  }

  const addContact = () => {
    if (value.contacts.length >= 2) return

    update([...value.contacts, {
      mode: 'manual',
      name: '',
      phone: '',
      address: ''
    }])
  }

  const setRadioValue = (mode, index) => {
    value.contacts[index].mode = mode;
    update(value.contacts)
  }

  const setManualContact = (contact, index) => {
    console.log("contact: ", index, contact)
    const newContacts = [...value.contacts]
    newContacts[index] = contact;

    update(newContacts)
  }

  const removeContact = (index) => {
    update(value.contacts.filter((_, i) => i !== index))
  }

  return (
   <SectionEmergency>
                        <EmergencyHeader>
                             <ImageIcon2 src={EmergencyIcon}/>
                            <EmergencyHeaderTitle>מידע חירום</EmergencyHeaderTitle>
                        </EmergencyHeader>
                       {value.contacts.map((contact, index) => (
                        <SingleEmergencyContact>
                            <TopContainer>
                                <Title>איש קשר למקרה חירום {index+1}</Title>
                                {!disableEdit && <StyledIconButton onClick={() => removeContact(index)}><StyledDelete /></StyledIconButton>}
                            </TopContainer>

                            <BottomContainer>
                                <RowContainer>
                                  {!disableEdit && <>
                                    <Label>מקור</Label>
                                    <RadioContainer>
                                        <RadioGroup
                                            aria-label="secommunitylect-"
                                            value={contact.mode}
                                            onChange={(e) => {
                                                setRadioValue(e.target.value, index)
                                            }}
                                            row
                                        >
                                            <StyledFormControlLabel value="select_from_list" control={<Radio />} label="בחירה מהמערכת" />
                                            <StyledFormControlLabel value="manual" control={<Radio />} label="הזנה ידנית" />
                                        </RadioGroup>
                                    </RadioContainer>
                                    {contact.mode == "select_from_list" && 
                                    <>
                                        <Label>בחר איש קשר למקרה חירום</Label>
                                        <StyledSelect
                                            autoFocus
                                            value={contact.id ?? ''}
                                            onChange={(event) => {
                                                const user = imsUsersStore.users.find(u => String(u.userId ?? u.id) === event.target.value)
                                                if (user) {
                                                  setManualContact({
                                                    ...contact,
                                                    id: String(user.userId ?? user.id),
                                                    name: user.fullName,
                                                    phone: user.mainMobilePhone,
                                                  }, index)
                                                }
                                            }}
                                        >
                                            <option value="">בחר...</option>
                                            {imsUsersStore.users.map(u => (
                                                <option key={u.userId ?? u.id} value={String(u.userId ?? u.id)}>
                                                  {u.mainMobilePhone && `(${displayPhone(u.mainMobilePhone)})`} {u.fullName} 
                                                </option>
                                            ))}
                                        </StyledSelect>
                                    </>}
                                    </>}   
                                    {contact.mode == "manual" && 
                                    <>
                                        <Label>שם מלא</Label>
                                        <StyledInput 
                                          autoFocus 
                                          placeholder='שם איש הקשר לשעת חירום'
                                          disabled={disableEdit}
                                          value={contact.name}
                                          onChange={e =>
                                            setManualContact({ ...contact, name: e.target.value }, index)
                                          }
                                        />
                                        <Label>טלפון</Label>
                                        <StyledInput
                                          autoFocus
                                          disabled={disableEdit}
                                          value={displayPhone(contact.phone)}
                                          placeholder="05-XXXXXXXX"
                                          dir="ltr"
                                          style={{ textAlign: 'right' }}
                                          onChange={e =>
                                            setManualContact({ ...contact, phone: normalizePhone(e.target.value) }, index)
                                          }
                                        /> 
                                        <Label>כתובת</Label>
                                        <StyledInput 
                                          autoFocus 
                                          disabled={disableEdit}
                                          value={contact.address}
                                          placeholder='כתובת מלאה'
                                          onChange={e =>
                                            setManualContact({ ...contact, address: e.target.value }, index)
                                          }
                                        />       
                                    </>}    
                                </RowContainer>
                                <RowContainer>
                                </RowContainer>
                            </BottomContainer>
                        </SingleEmergencyContact>
                      ))}
                        {!disableEdit && <EmergencyContainerButton disabled={value.contacts.length >= 2} onClick={addContact}><Add/>
הוספת איש קשר למקרה חירום ({value.contacts.length}/2)
                        </EmergencyContainerButton>}

                        {disableEdit && <ContactPersonContainer>
                          <ContactPersonLabel>מקור: איש קשר מהמערכת</ContactPersonLabel>
                          </ContactPersonContainer>}
                    </SectionEmergency>
                    
  )
}

export default observer(EmergencySection)


